"use client";

import { Show, SignInButton } from "@clerk/tanstack-react-start";
import { Sparkles } from "lucide-react";

import { SectionHeader } from "#/components/SectionHeader";
import { Badge } from "#/components/ui/badge";
import { Button } from "#/components/ui/button";
import { CardDescription, CardFooter, CardHeader, CardTitle } from "#/components/ui/card";

import { PromoCardShell } from "./-premium.promoCardShell";

const earlyBirdCtaClassName =
  "mx-auto h-11 w-full max-w-sm text-base font-semibold shadow-md shadow-premium/25";

function EarlyBirdPromoHeader() {
  return (
    <CardHeader className="relative gap-3 text-center">
      <Badge className="mx-auto bg-premium px-3 py-1 text-sm font-semibold text-premium-foreground">
        <Sparkles className="size-3.5" aria-hidden />
        Limited time offer
      </Badge>
      <CardTitle>
        <SectionHeader className="text-3xl text-foreground sm:text-4xl">Early Bird</SectionHeader>
      </CardTitle>
      <CardDescription className="text-base text-foreground">
        Early players get free premium <span className="font-bold">forever</span>. Premium gives you
        a second map every day, plus full access to the archive.
      </CardDescription>
    </CardHeader>
  );
}

function EarlyBirdPromoActions() {
  return (
    <CardFooter className="relative flex flex-col gap-3 border-t border-premium/25 bg-premium/8 pt-6">
      <Show when="signed-in">
        <Button
          variant="premium"
          size="lg"
          className={earlyBirdCtaClassName}
          nativeButton={false}
          render={<a href="/api/billing/early-bird" />}
        >
          Claim early bird discount
        </Button>
      </Show>
      <Show when="signed-out">
        <SignInButton mode="modal">
          <Button variant="premium" size="lg" className={earlyBirdCtaClassName}>
            Sign in to claim
          </Button>
        </SignInButton>
      </Show>
    </CardFooter>
  );
}

export function EarlyBirdPromoCard() {
  return (
    <PromoCardShell>
      <EarlyBirdPromoHeader />
      <EarlyBirdPromoActions />
    </PromoCardShell>
  );
}
